/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { BreadcrumbLink, Breadcrumbs } from '@squiz/sds';
import { useCapabilityBreadcrumbs } from 'apps/console-core/src/Hooks/UseCapabilityBreadcrumbs/UseCapabilityBreadcrumbs';
import { getCapabilityPath } from 'apps/console-core/src/Utilities/GetCapabilityPath/GetCapabilityPath';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AI_STRINGS } from '../../Constants/Strings.constants';
import { getAiContextPath } from '../../Utilities/getAiContextPath';
import { getContentToolPath } from '../../Utilities/getContentToolPath';
import { AiBreadcrumbsProps } from './AiBreadcrumbs.props';

export const AiBreadcrumbs = ({ ai, context }: AiBreadcrumbsProps): JSX.Element => {
  const capabilityBreadcrumbs: Array<BreadcrumbLink> = useCapabilityBreadcrumbs();
  const { t } = useTranslation();
  const labels = useMemo(
    () => ({
      aiChatbots: t(AI_STRINGS.aiChatbots),
    }),
    [t],
  );
  const [breadcrumbs, currentPageName] = useMemo(() => {
    const breadcrumbs = [
      ...capabilityBreadcrumbs,
      {
        name: labels.aiChatbots,
        url: getCapabilityPath('/ai-chatbots'),
      },
      {
        name: ai.name,
        url: getCapabilityPath(`/ai-chatbots${getContentToolPath(ai.id)}`),
      },
    ];

    if (context) {
      breadcrumbs.push({
        name: context.name,
        url: getCapabilityPath(getAiContextPath(ai.type, ai.id, context.id)),
      });
    }

    const currentPageName = breadcrumbs.pop()!.name;

    return [breadcrumbs, currentPageName];
  }, [ai, capabilityBreadcrumbs, context, labels]);

  return <Breadcrumbs currentPageName={currentPageName} links={breadcrumbs} />;
};
